import { Component, HostBinding, Input, OnInit, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { getLorenzFormLayoutEnumString, LibFormValidityDotComponent, LorenzFormComponentDisplayOptions, LorenzFormControl, LorenzFormGroup, LorenzFormLayoutEnum } from '@lib/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'lib-form-control-object',
	templateUrl: './lib-form-control-object.component.html',
	imports: [ReactiveFormsModule, LibFormValidityDotComponent, TranslateModule],
	styleUrl: './lib-form-control-object.component.scss'
})
export class LibFormControlObjectComponent implements OnInit {
	@Input({ required: true, alias: 'control' }) lorenzFormControl!: LorenzFormControl;

	@Input({ required: false, alias: 'options' }) lorenzFormComponentDisplayOptions: LorenzFormComponentDisplayOptions = {};

	@HostBinding('attr.class') hostCssClass = '';

	lorenzFormGroup!: LorenzFormGroup;

	computedValue: any;

	title = signal<string | null>(null);

	ngOnInit() {
		this.lorenzFormGroup = this.lorenzFormControl.parent as LorenzFormGroup;

		this.lorenzFormControl.payload.displayOptions = this.lorenzFormComponentDisplayOptions;

		// prettier-ignore
		this.hostCssClass = [
				this.lorenzFormControl.getKey(),
				getLorenzFormLayoutEnumString(this.lorenzFormComponentDisplayOptions?.layout ?? null)
			].join(' ');

		this.updateValueAndTitle(this.lorenzFormControl.value);

		// Abonniere Änderungen am FormControl
		this.lorenzFormControl.valueChanges.subscribe((value) => {
			this.updateValueAndTitle(value);
		});
	}

	get isLayoutFloatingLabels(): boolean {
		return this.lorenzFormComponentDisplayOptions?.layout === LorenzFormLayoutEnum.FLOATING_LABELS;
	}

	get showErrorMessages(): boolean {
		return this.lorenzFormControl.showErrors() && (this.lorenzFormComponentDisplayOptions?.showErrorMessages ?? true);
	}

	private updateValueAndTitle(value: any): void {
		// TODO setTimeout to quickfix "ExpressionChangedAfterItHasBeenCheckedError"
		setTimeout(() => {
			if (this.lorenzFormControl.payload && typeof this.lorenzFormControl.payload.displayFunction === 'function') {
				this.computedValue = this.lorenzFormControl.payload.displayFunction(value);
			} else {
				this.computedValue = value;
			}

			if (this.lorenzFormControl?.payload?.titleFunction instanceof Function) {
				this.title.set(this.lorenzFormControl.payload.titleFunction(value));
			}
		}, 0);
	}
}
